import { ChangeDetectionStrategy, Component, inject, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { AsyncApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { Isin } from '../../models/isin.model';
import { IsinFormComponent } from '../../forms/isin-form/isin-form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-new-isin-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Drawer, Button, IsinFormComponent],
  templateUrl: './new-isin-side-panel.html'
})
export class NewIsinSidePanelComponent extends AbstractToggleSidePanelComponent<Isin>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly isinApiEnum = EntityApiEnum.FIN_ISIN;

  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: Isin): void {
    
  }
  
  public readonly form: FormGroup<any> =this.formFactory.createIsinForm();
  public readonly data = model<Isin>();

  async onSaveClicked() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const generalValues = this.form.getRawValue() as Isin;     
      const isinSaved: Isin = await this.asyncApi.insert(this.isinApiEnum, generalValues);
      this.onSave.emit(isinSaved);
    }
  }
}